import React from 'react';
import { Field } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import AtlasV2MetricListContainer from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricListContainer';
import AtlasV2ProductListContainer from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2ProductListContainer';

const fields: Field[] = [
  {
    name: 'retailSales',
    displayName: 'RETAIL SALES'
  },
  {
    name: 'retailPrice',
    displayName: 'RETAIL PRICE'
  },
  {
    name: 'unitsSold',
    displayName: 'UNITS SOLD'
  }
];

/**
 * Shows product grid for prices summary
 */
const AtlasV2PricesProductGrid = () => {
  const { isProductEntity } = useProductEntity();
  const weekEndingFields = fields.map(removeComparisonFormatter);

  return isProductEntity ? (
    <AtlasV2MetricListContainer
      entityTableHeaderProps={{
        title: 'Retail Price by Week'
      }}
      indexName="sales"
      sortFieldName="retailSales"
      fields={weekEndingFields}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '308px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
      appTableProps={{
        sx: {
          'tr td:nth-of-type(2)': {
            width: '308px'
          },
          'tr td:nth-of-type(3)': {
            width: '306px'
          }
        }
      }}
    />
  ) : (
    <AtlasV2ProductListContainer
      indexName="sales"
      fields={fields}
      mainFieldName="retailPrice"
      sortFieldName="retailSales"
      entityTableHeaderProps={{
        title: 'Retail Price by Product'
      }}
      appTableProps={{
        sx: {
          'tr td:first-child': {
            width: 612,
            'div.product-col': {
              width: 'unset !important'
            }
          }
        }
      }}
    />
  );
};

export default AtlasV2PricesProductGrid;
